import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's no hash, scroll to top
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      // If there's a hash, wait for the page to render then scroll to element
      const scrollToElement = () => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          // Use a slight delay to ensure content is loaded
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      };

      scrollToElement();
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;